import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import typeCheck from 'common/util/typeCheck';
import extractPhoneFromText from 'common/util/extractPhoneFromText';

import log from 'client/lib/log';
import branch from 'client/core/branch';

import { SR_API_ACTION_GET_USER_BY_PHONE_HOUSEHOLD_ID } from 'api/actionTypes';

@withRouter
@branch({})
class SrSearchByPhoneHouseholdIdAndRedirectForm extends Component {
  static propTypes = {
    getRedirectionPath: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    apiClient: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      searchTerm: '',
    };
    this._isUnmounting = false;
  }

  componentWillUnmount() {
    this._isUnmounting = true;
  }

  _onInputChange = (event) => {
    this.setState({
      searchTerm: event.target.value.trim(),
    });
  };

  _onSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const { apiClient, getRedirectionPath, history } = this.props;
    const { searchTerm } = this.state;

    const phone = extractPhoneFromText(searchTerm);

    apiClient
      .post(SR_API_ACTION_GET_USER_BY_PHONE_HOUSEHOLD_ID, {
        phone,
        householdId: Number(searchTerm),
      })
      .then(async (user) => {
        if (this._isUnmounting) {
          return;
        }
        if (!user) {
          global.alert(
            `User with phone "${phone}" and household with id "${searchTerm}" not found.`,
          );
          return;
        }
        this.setState({
          searchTerm: '',
        });
        const redirectionPath = await getRedirectionPath(user);
        typeCheck('redirectionPath::NonEmptyString', redirectionPath);
        history.push(redirectionPath);
      })
      .catch((error) => {
        log.error(error);
      });
  };

  render() {
    const { searchTerm } = this.state;
    return (
      <form method="post" onSubmit={this._onSubmit} className="searchContainer">
        <input onChange={this._onInputChange} value={searchTerm} placeholder="search" />
        <button type="submit" />
      </form>
    );
  }
}

SrSearchByPhoneHouseholdIdAndRedirectForm.displayName = 'SrSearchByPhoneAndRedirectForm';

export default SrSearchByPhoneHouseholdIdAndRedirectForm;
